require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/node_modules/core-js/modules/es6.array.species.js
// module id = 325
// module chunks = 1